export const newProductGroup = {
  attributes: {
    name: '',
  },
}
